import React from "react";
import { motion } from "framer-motion";
import SlideOverlay from "./SlideOverlay";

const SlideAutonomous = React.memo(function SlideAutonomous() {
  return (
    <>
      <div
        className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000"
        style={{
          backgroundImage: `url(./carousel_img/autonomous_bg.webp)`,
          backgroundColor: "#1e1e21",
          willChange: "transform",
          contain: "layout style paint",
        }}
      >
        <img
          src="./carousel_img/autonomous_bg.webp"
          alt=""
          className="hidden"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0" />
      </div>

      <SlideOverlay
        label="Next-Generation Architecture"
        title="Autonomous Systems"
        description="Deploy self-learning AI agents that continuously evolve within your environment, anticipating business needs and executing complex multi-step workflows autonomously"
        ctaText="Explore Architecture"
        ctaUrl="/deployment/edge"
      >
        <motion.img
          src="./carousel_img/autonomous.webp"
          alt="Autonomous Systems visualization"
          width={940}
          height={600}
          initial={{ y: 40, opacity: 0 }}
          animate={{ x: 0, y: 0, opacity: 1 }}
          transition={{ delay: 1.4, duration: 0.25 }}
          className="absolute bottom-[190px] left-1/2 transform -translate-x-1/2 w-[800px] lg:w-[1200px] h-auto rounded-full mix-blend-screen -ml-[200px] lg:-ml-[300px] pointer-events-none z-10"
          loading="lazy"
          decoding="async"
        />
      </SlideOverlay>
    </>
  );
});

export default SlideAutonomous;

